module.exports = __webpack_public_path__ + "static/media/background.f7f9bf62.png";